"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jaLocaleData = require("i18next-icu/locale-data/ja");
exports.default = jaLocaleData;
//# sourceMappingURL=ja.js.map